module.exports = __webpack_public_path__ + "img/Truppführer_TW.16d9d43f.svg";